import React from 'react';
import { List } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { requestUrl } from '@/constants/urls';
import { resolveRequestWorkflow } from '../../state/state';

const SystemCohortListItem = ({
  code,
  name,
  link,
}) => (
  <List.Item className="aridhia-request-system-cohort-list-item">
    <List.Header>
      <FormattedMessage id="request.list.cohort.title" />
    </List.Header>
    {link && (
      <List.Description className="aridhia-form-item-description">
        <Link to={`${requestUrl({ code })}/cohort`} title={name}>
          {name}
        </Link>
      </List.Description>
    )}
    {!link && (<List.Description className="aridhia-form-item-description" content={name} />)}
  </List.Item>
);

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps);

  return (
    {
      name: request?.cohort?.name,
    }
  );
};

export default connect(mapStateToProps)(SystemCohortListItem);
